import { pdf } from "@react-pdf/renderer";

const useCustomReactPdf = () => {
  return {
    /**
     * Gera um PDF a partir de um componente React PDF e dispara automaticamente o download no navegador.
     *
     * @async
     * @function generatePdf
     * @param {Object} props - Parâmetros da função.
     * @param {React.ReactElement} props.component - Componente React PDF (geralmente um <Document> com páginas).
     * @param {string} props.name - Nome do arquivo PDF a ser baixado (sem a extensão .pdf).
     * @returns {Promise<void>} Uma Promise que resolve após o download do PDF ser iniciado.
     *
     * @example
     * generatePdf({
     *   component: <MeuDocumento dados={...} />,
     *   name: "relatorio-final"
     * });
     */
    async generatePdf(props: {
      component: Parameters<typeof pdf>[0];
      name: string;
    }): Promise<void> {
      const blob = await pdf(props.component).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${props.name}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    },
  };
};

export default useCustomReactPdf;
